import { get } from "lodash";
import { toSentence } from "LIB/formatters/text";

export const restrictedEntityToSentence = details => {
  const results = get(details, "results", []);

  return toSentence(results.map(f => f.name));
};

export const restrictedAddressesToSentence = details => {
  const results = get(details, "results", []);

  return toSentence(results.map(r => r.individual_address));
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/helpers.js